import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
import Kamula from "../../img/kamulah.png";
import Fitclub from "../../img/fitclub.png";

import { themeContext } from "../../Context";
const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{color: darkMode?'white': ''}}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >
        <SwiperSlide>
          <img src={Fitclub} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Kamula} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Fitclub} alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;